// extracted by css-extract-rspack-plugin
module.exports =  {"y-axis":"AnimatingAvatar-Ifv___y-axis","yAxis":"AnimatingAvatar-tY_p__yAxis","x-axis":"AnimatingAvatar-OzHm__x-axis","xAxis":"AnimatingAvatar-fovx__xAxis"};